import { render, staticRenderFns } from "./singleYY.vue?vue&type=template&id=09aab22a&scoped=true"
import script from "./singleYY.vue?vue&type=script&lang=js"
export * from "./singleYY.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09aab22a",
  null
  
)

export default component.exports